import { render, staticRenderFns } from "./EdlAlert.vue?vue&type=template&id=83ac2732&scoped=true&"
import script from "./EdlAlert.vue?vue&type=script&lang=js&"
export * from "./EdlAlert.vue?vue&type=script&lang=js&"
import style0 from "./EdlAlert.vue?vue&type=style&index=0&id=83ac2732&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ac2732",
  null
  
)

export default component.exports